import React from 'react';
import SingleValue from '@splunk/dashboard-visualizations/SingleValue';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import EventsDoc from '@splunk/dashboard-visualizations/common/EventsDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicCode from '!!raw-loader!./examples/Basic';
import FieldFooCode from '!!raw-loader!./examples/FieldFoo';
import FieldBarCode from '!!raw-loader!./examples/FieldBar';
import BackgroundColorCode from '!!raw-loader!./examples/BackgroundColor';
import BackgroundColorWhiteCode from '!!raw-loader!./examples/BackgroundColorWhite';
import CustomFontSizesCode from '!!raw-loader!./examples/CustomFontSizes';
import NoSparklineCode from '!!raw-loader!./examples/NoSparkline';
import NoTrendIndicatorCode from '!!raw-loader!./examples/NoTrendIndicator';
import NoThousandSeparatorsCode from '!!raw-loader!./examples/NoThousandSeparators';
import TrendModePercentCode from '!!raw-loader!./examples/TrendModePercent';
import PrecisionCode from '!!raw-loader!./examples/Precision';
import UnderLabelCode from '!!raw-loader!./examples/UnderLabel';
import UnitAfterCode from '!!raw-loader!./examples/UnitAfter';
import UnitBeforeCode from '!!raw-loader!./examples/UnitBefore';
import NoTrendUnitCode from '!!raw-loader!./examples/NoTrendUnit';
import TrendUnitCode from '!!raw-loader!./examples/TrendUnit';
import SparklineBeforeCode from '!!raw-loader!./examples/SparklineBefore';
import SparklineAfterCode from '!!raw-loader!./examples/SparklineAfter';
import SparklineAreaGraphCode from '!!raw-loader!./examples/SparklineAreaGraph';
import StrokeColorCode from '!!raw-loader!./examples/StrokeColor';
import FillColorCode from '!!raw-loader!./examples/FillColor';
import SparklineNullCode from '!!raw-loader!./examples/SparklineNull';
import SparklineNoNullCode from '!!raw-loader!./examples/SparklineNoNull';
import SparklineHighLightCode from '!!raw-loader!./examples/SparklineHighlight';
import ColorDataSeriesCode from '!!raw-loader!./examples/ColorDataSeries';
import ColorDataSeriesAreaGraphCode from '!!raw-loader!./examples/ColorDataSeriesAreaGraph';
import EncodingColumnIndexCode from '!!raw-loader!./examples/EncodingColumnIndex';
import EncodingFormatCode from '!!raw-loader!./examples/EncodingFormat';
import EncodingFormatMatchCode from '!!raw-loader!./examples/EncodingFormatMatch';
import EncodingFormatColumnIndexCode from '!!raw-loader!./examples/EncodingFormatColumnIndex';
import EncodingFormatMatchMajorColorCode from '!!raw-loader!./examples/EncodingFormatMatchMajorColor';

import BasicExample from './examples/Basic';
import FieldFooExample from './examples/FieldFoo';
import FieldBarExample from './examples/FieldBar';
import BackgroundColorExample from './examples/BackgroundColor';
import BackgroundColorWhiteExample from './examples/BackgroundColorWhite';
import CustomFontSizesExample from './examples/CustomFontSizes';
import NoSparklineExample from './examples/NoSparkline';
import NoTrendIndicatorExample from './examples/NoTrendIndicator';
import NoThousandSeparatorsExample from './examples/NoThousandSeparators';
import TrendModePercentExample from './examples/TrendModePercent';
import PrecisionExample from './examples/Precision';
import UnderLabelExample from './examples/UnderLabel';
import UnitAfterExample from './examples/UnitAfter';
import UnitBeforeExample from './examples/UnitBefore';
import NoTrendUnitExample from './examples/NoTrendUnit';
import TrendUnitExample from './examples/TrendUnit';
import SparklineBeforeExample from './examples/SparklineBefore';
import SparklineAfterExample from './examples/SparklineAfter';
import SparklineAreaGraphExample from './examples/SparklineAreaGraph';
import StrokeColorExample from './examples/StrokeColor';
import FillColorExample from './examples/FillColor';
import SparklineNullExample from './examples/SparklineNull';
import SparklineNoNullExample from './examples/SparklineNoNull';
import SparklineHighLightExample from './examples/SparklineHighlight';
import ColorDataSeriesExample from './examples/ColorDataSeries';
import ColorDataSeriesAreaGraphExample from './examples/ColorDataSeriesAreaGraph';
import EncodingColumnIndexExample from './examples/EncodingColumnIndex';
import EncodingFormatExample from './examples/EncodingFormat';
import EncodingFormatMatchExample from './examples/EncodingFormatMatch';
import EncodingFormatColumnIndexExample from './examples/EncodingFormatColumnIndex';
import EncodingFormatMatchMajorColorExample from './examples/EncodingFormatMatchMajorColor';

import doc from './definition';
import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Dashboard Single Value"
        description="Wrapper around the Single Value Standard visualization that maps a datasource to values to display. This visualization has been upgraded in @splunk/visualizations/SingleValue and may be used in UDF."
        examplesSection={[
            <DocExample title="Basic Single Value" key="basic" code={BasicCode} example={BasicExample} />,
            <DocExample
                title="Encoding Field is foo"
                key="fieldfoo"
                code={FieldFooCode}
                example={FieldFooExample}
            />,
            <DocExample
                title="Encoding Field is bar"
                key="fieldbar"
                code={FieldBarCode}
                example={FieldBarExample}
            />,
            <DocExample
                title="Basic Single Value. Background Color is red"
                key="backgroundcolor"
                code={BackgroundColorCode}
                example={BackgroundColorExample}
            />,
            <DocExample
                title="Basic Single Value. Background Color is white"
                key="backgroundcolorwhite"
                code={BackgroundColorWhiteCode}
                example={BackgroundColorWhiteExample}
            />,
            <DocExample
                title="Major Font Size is 40, Delta Font Size is 30"
                key="customfontsizes"
                code={CustomFontSizesCode}
                example={CustomFontSizesExample}
            />,
            <DocExample
                title="Sparkline is disabled"
                key="nosparkline"
                code={NoSparklineCode}
                example={NoSparklineExample}
            />,
            <DocExample
                title="Trend Indicator is disabled"
                key="notrendindicator"
                code={NoTrendIndicatorCode}
                example={NoTrendIndicatorExample}
            />,
            <DocExample
                title="Thousand Separators is disabled"
                key="nothousandseparators"
                code={NoThousandSeparatorsCode}
                example={NoThousandSeparatorsExample}
            />,
            <DocExample
                title="Trend Display Mode is percent"
                key="trendmodepercent"
                code={TrendModePercentCode}
                example={TrendModePercentExample}
            />,
            <DocExample
                title="Trend Display Unit is disabled, default"
                key="notrendunit"
                code={NoTrendUnitCode}
                example={NoTrendUnitExample}
            />,
            <DocExample
                title="Trend Display Unit is enabled"
                key="trendunit"
                code={TrendUnitCode}
                example={TrendUnitExample}
            />,
            <DocExample
                title="Precision is 2"
                key="precision"
                code={PrecisionCode}
                example={PrecisionExample}
            />,
            <DocExample
                title="Under Label is specified"
                key="underlabel"
                code={UnderLabelCode}
                example={UnderLabelExample}
            />,
            <DocExample
                title="Unit is specified, Unit Position is after, default"
                key="unitafter"
                code={UnitAfterCode}
                example={UnitAfterExample}
            />,
            <DocExample
                title="Unit is specified, Unit Position is before"
                key="unitbefore"
                code={UnitBeforeCode}
                example={UnitBeforeExample}
            />,
            <DocExample
                title="Sparkline Position is before values"
                key="sparklinebefore"
                code={SparklineBeforeCode}
                example={SparklineBeforeExample}
            />,
            <DocExample
                title="Sparkline Position is after values, Sparkline Tooltip is on"
                key="sparklineafter"
                code={SparklineAfterCode}
                example={SparklineAfterExample}
            />,
            <DocExample
                title="Sparkline Area Graph is true"
                key="SparklineAreaGraph"
                code={SparklineAreaGraphCode}
                example={SparklineAreaGraphExample}
            />,
            <DocExample
                title="Sparkline Stroke Color is red"
                key="strokecolor"
                code={StrokeColorCode}
                example={StrokeColorExample}
            />,
            <DocExample
                title="Sparkline Fill Color is blue"
                key="fillcolor"
                code={FillColorCode}
                example={FillColorExample}
            />,
            <DocExample
                title="Sparkline Accept Null is enabled, default"
                key="sparklinenull"
                code={SparklineNullCode}
                example={SparklineNullExample}
            />,
            <DocExample
                title="Sparkline Accept Null is disabled"
                key="sparklinenonull"
                code={SparklineNoNullCode}
                example={SparklineNoNullExample}
            />,
            <DocExample
                title="Sparkline Highlight Segments is 3, Sparkline Highlight Dots is 4"
                key="sparklinehighlight"
                code={SparklineHighLightCode}
                example={SparklineHighLightExample}
            />,
            <DocExample
                title="Color data series specified"
                key="colordataseries"
                code={ColorDataSeriesCode}
                example={ColorDataSeriesExample}
            />,
            <DocExample
                title="Color data series specified, Sparkline Area Graph is true, Sparkline Fill Color is red"
                key="colordataseriesareagraph"
                code={ColorDataSeriesAreaGraphCode}
                example={ColorDataSeriesAreaGraphExample}
            />,
            <DocExample
                title="Encoding column index specified"
                key="encodingcolumnindex"
                code={EncodingColumnIndexCode}
                example={EncodingColumnIndexExample}
            />,
            <DocExample
                title="Encoding format specified"
                key="encodingformat"
                code={EncodingFormatCode}
                example={EncodingFormatExample}
            />,
            <DocExample
                title="Encoding format specified, match formatter used for fill color"
                key="encodingformatmatch"
                code={EncodingFormatMatchCode}
                example={EncodingFormatMatchExample}
            />,
            <DocExample
                title="Encoding format column index specified"
                key="encodingformatcolumnindex"
                code={EncodingFormatColumnIndexCode}
                example={EncodingFormatColumnIndexExample}
            />,
            <DocExample
                title="Encoding format specified, match formatter used for majorColor"
                key="encodingformatmatchmajorcolor"
                code={EncodingFormatMatchMajorColorCode}
                example={EncodingFormatMatchMajorColorExample}
            />,
        ]}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
        optionSection={<OptionsDoc options={optionsSchema} />}
        eventSection={
            <EventsDoc
                events={doc.events}
                Visualization={SingleValue}
                encoding={{}}
                dsState={{
                    primary: {
                        data: {
                            columns: [
                                ['1', '62', '103', '308', '587', '876', '930', '1320'],
                                [
                                    '2018-08-19T00:00:00.000+00:00',
                                    '2018-08-20T00:00:00.000+00:00',
                                    '2018-08-21T00:00:00.000+00:00',
                                    '2018-08-22T00:00:00.000+00:00',
                                    '2018-08-23T00:00:00.000+00:00',
                                    '2018-08-24T00:00:00.000+00:00',
                                    '2018-08-25T00:00:00.000+00:00',
                                    '2018-08-26T00:00:00.000+00:00',
                                ],
                            ],
                            fields: [
                                {
                                    name: 'foo',
                                },
                                {
                                    name: '_time',
                                },
                            ],
                        },
                        meta: {},
                    },
                }}
            />
        }
    />
);
